<template>
  <div>
    <div class="notification is-info is-light">
      <strong>Κατάσταση συστάσεων</strong>
      <ul>
        <li>
          <b>Γράφτηκε</b>: ο φίλος εγγράφηκε με τον κωδικό και έλαβε ήδη το
          κουπόνι του· αναμένεται παραδοθείσα qualifying παραγγελία 20€+ και
          κανείς δεν έχει ακόμη πόντους.
        </li>
        <li>
          <b>Ολοκληρώθηκε</b>: παραδόθηκε qualifying παραγγελία· απονεμήθηκαν
          10.000 πόντοι στον καθένα και εκδόθηκε κουπόνι στον referrer.
        </li>
        <li>
          <b>Ακυρώθηκε</b>: σταμάτησε από την ομάδα πριν την ανταμοιβή· ο φίλος
          κρατά το κουπόνι εγγραφής και κανείς δεν παίρνει πόντους.
        </li>
      </ul>
      <p class="mb-0">
        Η στήλη πόντων είναι φίλος / referrer και η ακύρωση είναι οριστική,
        χωρίς email.
      </p>
    </div>
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">Συστάσεις</p>
        <div class="card-header-icon">
          <button
            class="button is-small"
            type="button"
            @click="exportReferrals"
          >
            Εξαγωγή XLSX
          </button>
        </div>
      </header>
      <div class="card-content">
        <Filters
          :options="options"
          :filters="filters"
          :is-loading="isFiltering"
          general-label="Αναζήτηση email ή κωδικού"
          @navigate="navigate"
        />
        <NewPagination
          :items="items"
          :total="total"
          :current-page="currentPage"
          :pages-count="pagesCount"
          :items-per-page="itemsPerPage"
          :is-loading="isLoading"
          @navigate="navigate"
        />
        <LoadingContainer :is-loading="isLoading" :is-opaque="items.length > 0">
          <div v-if="items.length" class="table-container">
            <table class="table is-bordered is-striped is-fullwidth">
              <thead>
                <tr>
                  <th>Ημερομηνία</th>
                  <th>Referrer</th>
                  <th>Κωδικός</th>
                  <th>Φίλος</th>
                  <th>Κατάσταση</th>
                  <th>Αξία προϊόντων μετά τις εκπτώσεις</th>
                  <th>Πόντοι</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.uuid || item.id">
                  <td>{{ item.registered_at | timestamp }}</td>
                  <td>{{ person(item.referrer) }}</td>
                  <td>{{ item.code }}</td>
                  <td>{{ person(item.referred) }}</td>
                  <td>
                    <span :class="['tag', statusClass(item.status)]">{{
                      statusLabel(item.status)
                    }}</span>
                  </td>
                  <td v-if="item.qualifying_order">
                    <div class="qualifying-order">
                      <router-link
                        :to="{
                          name: 'orders.edit',
                          params: { uuid: item.qualifying_order.uuid },
                        }"
                      >
                        {{ item.qualifying_order.common_id }}
                      </router-link>
                      <span aria-hidden="true">·</span>
                      <span>{{ item.qualifying_order.sum }}€</span>
                    </div>
                  </td>
                  <td v-else>—</td>
                  <td>{{ points(item) }}</td>
                  <td>
                    <button
                      v-if="item.status === 'registered'"
                      class="button is-small is-danger"
                      @click="cancel(item)"
                    >
                      Ακύρωση
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p v-else class="has-text-centered">Δεν βρέθηκαν συστάσεις.</p>
        </LoadingContainer>
      </div>
    </div>
    <Confirmation
      :is-open="isOpen"
      :is-saving="isSaving"
      title="Επιβεβαίωση ακύρωσης"
      description="Η ακύρωση είναι οριστική και δεν αποστέλλεται email."
      @closeModal="confirmCancel"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import request from '@/utils/request';
import PaginatedList from '@/views/components/PaginatedList';

export default {
  extends: PaginatedList,
  data: () => ({
    items: [],
    options: [
      {
        label: 'Γενική Αναζήτηση',
        title: 'general',
        type: 'string',
        value: null,
      },
      {
        label: 'Κατάσταση',
        title: 'status',
        type: 'select',
        value: null,
        options: [
          { label: 'Γράφτηκε', value: 'registered' },
          { label: 'Ολοκληρώθηκε', value: 'rewarded' },
          { label: 'Ακυρώθηκε', value: 'cancelled' },
        ],
      },
      {
        label: 'Ημερομηνία από',
        title: 'date_start',
        type: 'date',
        value: null,
      },
      { label: 'Ημερομηνία έως', title: 'date_end', type: 'date', value: null },
    ],
    filtersOptions: {
      general: '',
      status: null,
      date_start: null,
      date_end: null,
    },
    filters: {},
    isOpen: false,
    isSaving: false,
    pendingCancel: null,
  }),
  async beforeRouteEnter(to, from, next) {
    next(vm => vm.navigate());
  },
  methods: {
    ...mapActions('referrals', ['fetch']),
    person(person) {
      if (!person) return '—';
      return (
        person.email ||
        person.fullName ||
        [person.firstName, person.lastName].filter(Boolean).join(' ') ||
        '—'
      );
    },
    statusLabel(status) {
      if (status === 'rewarded') return 'Ολοκληρώθηκε';
      if (status === 'cancelled') return 'Ακυρώθηκε';
      return 'Γράφτηκε';
    },
    statusClass(status) {
      if (status === 'rewarded') return 'is-success';
      if (status === 'cancelled') return 'is-danger';
      return 'is-warning';
    },
    points(item) {
      return item.status === 'registered' || item.status === 'cancelled'
        ? '— / —'
        : `${
            item.referred_points !== null && item.referred_points !== undefined
              ? item.referred_points
              : 10000
          } / ${
            item.referrer_points !== null && item.referrer_points !== undefined
              ? item.referrer_points
              : 10000
          }`;
    },
    exportReferrals() {
      this.exportXLS(
        this.items.map(item => item.id),
        [
          { key: 'Ημερομηνία', value: 'registered_at' },
          { key: 'Κωδικός', value: 'code' },
          { key: 'Κατάσταση', value: 'status' },
          { key: 'Referrer', value: 'referrer.email' },
          { key: 'Φίλος', value: 'referred.email' },
        ],
        'referrals',
      );
    },
    async navigate(msg = {}) {
      const { page = 1, filters = this.filters } = msg;
      const itemsPerPage = msg.itemsPerPage || msg.size || this.itemsPerPage;
      this.isLoading = true;
      try {
        if (Object.prototype.hasOwnProperty.call(msg, 'filters')) {
          this.filters = filters;
        }
        const preparedFilters = this.prepareFilters(filters);
        const {
          general,
          date_start: dateStart,
          date_end: dateEnd,
          ...apiFilters
        } = preparedFilters;
        const data = await this.fetch({
          page,
          size: itemsPerPage,
          ...apiFilters,
          ...(general ? { search: general } : {}),
          ...(dateStart ? { from: dateStart } : {}),
          ...(dateEnd ? { to: dateEnd } : {}),
        });
        const rows = data.referrals || data;
        const pagination = Array.isArray(rows) ? { data: rows } : rows;
        this.items = pagination.data || [];
        this.currentPage = page;
        this.itemsPerPage = itemsPerPage;
        this.pagesCount = pagination.last_page || 1;
        this.total = pagination.total || 0;
        this.indexStartsFrom = pagination.from || 1;
      } catch (error) {
        this.$notify({
          type: 'error',
          title: 'Αποτυχία',
          text: 'Το αίτημα απέτυχε.',
        });
      } finally {
        this.isLoading = false;
      }
    },
    cancel(item) {
      this.pendingCancel = item;
      this.isOpen = true;
    },
    async confirmCancel(confirmed) {
      this.isOpen = false;
      if (!confirmed || !this.pendingCancel) return;
      this.isSaving = true;
      try {
        await request.put(`/referrals/${this.pendingCancel.uuid}/cancel`);
        this.$set(this.pendingCancel, 'status', 'cancelled');
        this.$notify({
          type: 'success',
          title: 'Επιτυχία',
          text: 'Η σύσταση ακυρώθηκε.',
        });
      } catch (error) {
        this.$notify({
          type: 'error',
          title: 'Αποτυχία',
          text: 'Η ακύρωση απέτυχε.',
        });
      } finally {
        this.isSaving = false;
        this.pendingCancel = null;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.table-container {
  overflow-x: auto;
}

.table-container table {
  min-width: 900px;
}

.qualifying-order {
  align-items: center;
  display: inline-flex;
  gap: 0.35rem;
  white-space: nowrap;
}
</style>
